import { Action } from 'redux'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const copyAddressValues = (formKey: string, formName): ICopyAddressValues => ({
  additionalGuestKey: formKey,
  formName,
  type: ReservationModalActions.CopyAddressValues,
})

export interface ICopyAddressValues
  extends Action<ReservationModalActions.CopyAddressValues> {
  formName: string
  additionalGuestKey: string
}

export { copyAddressValues }
